// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-rating-points-range {
  display: block;
  margin: 0 8px 56px 8px;
}

app-rating-review-filter {
  display: block;
}

.rating-wrapper {
  padding: 0 12px 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/page/components/search-page/components/rating-filter/rating-filter.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,sBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":["app-rating-points-range {\n  display: block;\n  margin: 0 8px 56px 8px;\n}\n\napp-rating-review-filter {\n  display: block;\n}\n\n.rating-wrapper {\n  padding: 0 12px 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
